import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import { connect } from 'react-redux';
import JSZip from "jszip";
import FileSaver from 'file-saver';
import { ReactReduxContext } from 'react-redux'

import { renderEmailString } from "./emailString";
import { buildMjmlSource, renderEmailMjml } from "./mjmlString";

const createZip = async (store) => {
    const state = store.getState();
    const zip = new JSZip();
    zip.file("email-campaign.html", renderEmailString(store));
    zip.file("email-campaign.mjml", buildMjmlSource(store));
    zip.file("email-campaign-mjml.html", await renderEmailMjml(store));

    const addImagesToZip = (section, content, index) => {
        if (content.config.src.indexOf('base64') !== -1) {
            const imageBase64 = content.config.src;
            const basePic =  imageBase64.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");  

            let extension;
            let lowerCase = imageBase64.toLowerCase();
            if (lowerCase.indexOf("png") !== -1)
                extension = "png"
            else if (lowerCase.indexOf("jpg") !== -1 || lowerCase.indexOf("jpeg") !== -1)
                extension = "jpg"
            else 
                extension = "tiff";

            zip.file(
                `${section}_image_${index}.${extension}`, 
                basePic, 
                {base64: true}
            );
        }
    };

    ['header', 'body', 'footer'].forEach((section) => {
        state.design[section].map((content, index) => {
            if (content.type === "image") {
                addImagesToZip(section, content, index);
            } else if(content.type === "ifelse") {
                content.config.if.content.map((ifContent, ifIndex) => {
                    addImagesToZip(`${section}_${index}_if`, ifContent, ifIndex);
                });
                content.config.else.content.map((elseContent, elseIndex) => {
                    addImagesToZip(`${section}_${index}_else`, elseContent, elseIndex);
                });
            } else if(content.type === "if") {
                content.config.if.content.map((ifContent, ifIndex) => {
                    addImagesToZip(`${section}_${index}_if`, ifContent, ifIndex);
                });
            }
        });
    });

    zip.generateAsync({ type: "blob" })
        .then(function (content) {
            FileSaver.saveAs(content, "email-campaign.zip");
        });
};

const ZipProject = ({ folder, iconOnly }) => {
    const onCreateZip = (store) => {
        createZip(store);
    }

    return (
        <ReactReduxContext.Consumer>
            {({ store }) => {
                return iconOnly ? (
                    <Tooltip title="Zip">
                        <IconButton aria-label="Zip" onClick={() => onCreateZip(store)}>
                            <FolderZipIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Button
                        color="inherit" variant="outlined" onClick={() => onCreateZip(store)}
                        startIcon={<FolderZipIcon />}>Zip</Button>
                )
            }}
        </ReactReduxContext.Consumer>
    );
}

const mapStateToProps = (state) => {
    return {
        folder: state.design.folder
    }
}

export default connect(
    mapStateToProps
)(ZipProject);